export enum Numbers {
  ONE = 1,
  FOUR = 4,
}

export enum AppRoutes {
  LOGIN = "/login",
  REGISTER = "/register",
  SUBMIT = "/submit",
  REGISTRATION_FORM = "/registration-form",
  PROFILE = "/profile",
  ADMIN = "/admin",
  MATRIMONY = "/matrimony",
  MATRIMONY_FORM = "/matrimony/form",
  HOME = "/home",
  LEGAL = "/legal-documents",
  JOIN_US = "/join-us",
  PRIVACY = "/privacy-policy",
  COMING_SOON = "/coming-soon",
  LANDING_PAGE = "/",
  DONATION_PAGE = "/donation",
  ALL_EVENTS = "/events",
  EVENT_DETAILS = "/event-details",
  FORGOT_PASSWORD  = "/forgot-password",
  REGISTRATION_GUIDELINES = "/registration-guidelines",
  MATRIMONY_PROFILE_DETAILS = "/matrimony/profile-details",
  MATRIMONY_SEARCH_RESULTS = "/matrimony/search",
  MATRIMONY_CONTACT_REQUEST = "/matrimony/contact-requests",
}

export enum StatusCode {
  SUCCESS_STATUS_CODE = 200,
  SUCCESS_NO_CONTENT_STATUS_CODE = 204,
  PARTIAL_CONTENT_STATUS_CODE = 206,
  CREATED_STATUS_CODE = 201,
  BAD_REQUEST = 400,
  Not_Acceptable = 406,
  NOT_AUTHORIZED_CODE = 401,
  INTERNAL_SERVER_ERROR_CODE = 500,
  NOT_FOUND = 404,
  EXPECTATION_FAILED = 417,
  REQUEST_ACCEPTED = 202,
}
